module.exports = __webpack_public_path__ + "img/banner4.6319f9d2.png";